import _lib from '../_lib';
import active from './active/index';
import {OrdersNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'orders';
  let activations = [
    {
      name: 'orders',
      test: api.messageIs(OrdersNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};